import { useState } from "react";
import { CircleCheck } from "lucide-react";
import type { Profile } from "./terra-boa-data";

export function AvatarVisual({ profile, className, verified = false, eager = false }: {
  profile: Pick<Profile, "name" | "initials" | "avatar">; className: string; verified?: boolean; eager?: boolean;
}) {
  const [failedUrl, setFailedUrl] = useState<string | null>(null);
  const url = profile.avatar?.url;
  const showPhoto = Boolean(url && url !== failedUrl);
  return <span className={`${className} profile-photo-frame${showPhoto ? " has-photo" : ""}`} role="img" aria-label={showPhoto ? `Foto de ${profile.name}` : `Iniciais de ${profile.name}`}>
    {showPhoto ? <img src={url} alt="" loading={eager ? "eager" : "lazy"} decoding="async" referrerPolicy="no-referrer" onError={() => setFailedUrl(url!)} /> : profile.initials}
    {verified && <i className="avatar-verification"><CircleCheck size={18} fill="#00bf63" /></i>}
  </span>;
}
